import { useEffect, useState, useCallback } from "react";
import { pendingCount, flush, OUTBOX_EVENT, SYNC_EVENT } from "@/lib/outbox";

// Sprint 35.0 — Estado de conectividad global para el indicador "EN VIVO".
// Estados: "live" (verde), "syncing" (ámbar), "offline" (rojo).
export function useConnectivity() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  const refreshPending = useCallback(async () => {
    setPending(await pendingCount());
  }, []);

  useEffect(() => {
    refreshPending();
    const onOnline = () => { setOnline(true); flush().catch(() => {}); };
    const onOffline = () => setOnline(false);
    const onChanged = () => refreshPending();
    const onSync = (e) => setSyncing(!!(e.detail && e.detail.syncing));
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener(OUTBOX_EVENT, onChanged);
    window.addEventListener(SYNC_EVENT, onSync);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener(OUTBOX_EVENT, onChanged);
      window.removeEventListener(SYNC_EVENT, onSync);
    };
  }, [refreshPending]);

  let status = "live";
  if (!online) status = "offline";
  else if (syncing || pending > 0) status = "syncing";

  return { online, pending, syncing, status };
}
